@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('view')) {
    <div class="account-main-wrapper" [ngClass]="{'expanded': isExpanded}"
      [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
      <div class="container-fluid mb-4" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
        <div class="main-section row m-2">
          <div class="amount-side-mian col-12 col-md-12 col-lg-12 col-xl-7 p-0" [hidden]="isExpanded">
            <div class="amount-side">
              <div class="available-money-main-section">
                <div class="available-money">
                  <div class="available-money-left">
                    <div class="money-detail">
                      <div class="accountsub-icon p-3">
                        <img src="../../assets/images/empty-wallet.png" alt="" />
                      </div>
                    </div>
                    <div class="account-heading">
                      <h1>Available</h1>
                      <p>{{total_Amount}}/- <span>PKR</span></p>
                    </div>
                  </div>
                  <div class="available-money-right">
                    <div class="money-icon-image">
                      <img src="../../assets/images/money-jar.png" alt="missing image">
                    </div>
                  </div>
                </div>
                <div class="amount-calculation-section">
                  <div class="total-deposit money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/card-receive.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{deposit}}/- <span>PKR</span></h1>
                      <p>Total Deposit</p>
                    </div>
                  </div>
                  <div class="reserved money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/card-tick.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{reserve}}/- <span>PKR</span></h1>
                      <p>Reserved</p>
                    </div>
                  </div>
                  <div class="expense money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/receipt-item.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{expense}}/- <span>PKR</span></h1>
                      <p>Expense</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="amount-side-mian col-12 col-md-12 col-lg-12 p-0" [hidden]="!isExpanded">
            @if (this.admin_id) {
              <div class="col-12">
                <h1></h1>
              </div>
            }
            <div class="amount-side">
              <div class="available-money-main-section1">
                <div class="available-money1">
                  <div class="available-money-left">
                    <div class="money-detail">
                      <div class="accountsub-icon p-3">
                        <img src="../../assets/images/empty-wallet.png" alt="" />
                      </div>
                    </div>
                    <div class="account-heading">
                      <h1>Available</h1>
                      <p>{{total_Amount}}/- <span>PKR</span></p>
                    </div>
                  </div>
                  <div class="available-money-right">
                    <div class="money-icon-image">
                      <img src="../../assets/images/money-jar.png" alt="missing image">
                    </div>
                  </div>
                </div>
                <div class="amount-calculation-section1">
                  <div class="total-deposit money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/card-receive.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{deposit}}/- <span>PKR</span></h1>
                      <p>Total Deposit</p>
                    </div>
                  </div>
                  <div class="reserved money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/card-tick.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{reserve}}/- <span>PKR</span></h1>
                      <p>Reserved</p>
                    </div>
                  </div>
                  <div class="expense money-detail-inner">
                    <div class="money-detail-inner-icon">
                      <img src="../../assets/images/receipt-item.png" alt="Missing" />
                    </div>
                    <div class="total-money">
                      <h1>{{expense}}/- <span>PKR</span></h1>
                      <p>Expense</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chart-side-mian col-12 col-md-12 col-lg-12 col-xl-5 pr-0" [hidden]="isExpanded">
            <div class="chart-side-dark">
              <div class=""
                [ngClass]="{ 'chart-header': selectedMode === 'dark', 'chart-header-light': selectedMode !== 'dark' }">
                <h1>Current Month</h1>
                <p>{{deposit}}</p>
              </div>
              <div class="chart-body">
                <ag-charts-angular style="height:100%;" [options]="options">
                </ag-charts-angular>
              </div>
            </div>
          </div>
        </div>
        <div class="account-table-wrapper mt-3" [ngClass]="{'dark-background': selectedMode === 'dark' }">
          <div class="col-12">
            <div class="account-table-filter mb-3">
              <div class="account-table-filter-heading">
                <h1>Transaction History</h1>
              </div>
              <div class="account-table-filter-buttons">
                <div class="select-reason table-button">
                  <div class="form-group type-filter" [ngClass]="{ 'dark-dropdown': selectedMode === 'dark' }">
                    <select id="type" name="type" data-toggle="dropdown" [(ngModel)]="selectedOption"
                      (change)="selectFunction()" class="dropdown-toggle checks-dropdown form-control pl-4">
                      <option [ngValue]="''" disabled selected>Select Reason</option>
                      <option [ngValue]="'reserve'">Reserve</option>
                      <option [ngValue]="'events'">Events</option>
                      <option [ngValue]="'sports'">Sports</option>
                      <option [ngValue]="'birthday'">Birthday</option>
                      <option [ngValue]="'patty_cash'">Patty Cash </option>
                      <option [ngValue]="'misalliance'">Misalliance </option>
                      <option [ngValue]="'available'">Available</option>
                      <option [ngValue]="'all'">All</option>
                    </select>
                  </div>
                </div>
                <div class="select-debit table-button">
                  <div class="form-group type-filter" [ngClass]="{ 'dark-dropdown': selectedMode === 'dark' }">
                    <select id="type" name="type" data-toggle="dropdown"
                      class="dropdown-toggle checks-dropdown form-control pl-4" [(ngModel)]="selectedOption"
                      (change)="selectexpense_typ()">
                      <option [ngValue]="''" disabled selected>Account Type</option>
                      <option [ngValue]="'debit'">Debit</option>
                      <option [ngValue]="'credit'">Credit</option>
                      <option [ngValue]="'both'">Both </option>
                    </select>
                  </div>
                </div>
                <div class="select-expand" (click)="toggleExpand()">
                  <div class="form-group">
                    <div class="expand button-border">
                      <img src="../../assets/images/expand.png" alt="Missing">
                    </div>
                  </div>
                </div>
                @if (isavailablefeature('export')) {
                  <div class="select-upload" data-toggle="modal" data-target="#addCvs">
                    <div class="form-group">
                      <div class="upload button-border">
                        <img src="../../assets/images/upload.png" alt="Missing">
                      </div>
                    </div>
                  </div>
                }
                @if (isavailablefeature('add')) {
                  <div class="add-new-sheet" data-toggle="modal"
                    data-target="#addexpense">
                    <div class="form-group">
                      <div class="add button-border">
                        <img src="../../assets/images/plus-button.png" alt="Missing">
                      </div>
                    </div>
                  </div>
                }
                <!-- Modal add CVS -->
                <div class="modal fade" id="addCvs" tabindex="-1" role="dialog" aria-labelledby="addCvs"
                  aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                      <div class="modal-header modal-heading-main">
                        <h5 class="modal-title" id="exampleModalLongTitle">Export CVS</h5>
                      </div>
                      <div class="modal-body">
                        <div class="modal-body-header">
                          <div class="export-type">
                            <label>Export Type</label>
                            <div class="form-group" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                              <select id="type" name="type" data-toggle="dropdown" [(ngModel)]="exportType"
                                class="dropdown-toggle checks-dropdown form-control pl-4">
                                <option value="" disabled selected>Date Sheet</option>
                                <option value="debit">Debit</option>
                                <option value="credit">Credit</option>
                                <option value="all_data">All Data</option>
                              </select>
                            </div>
                          </div>
                          <div class="export-type">
                            <label>Start Date</label>
                            <div class="form-group" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                              <input type="date" name="startDate" id="startDate" placeholder="Start Date"
                                [(ngModel)]="start_Date" />
                              </div>
                            </div>
                            <div class="export-type">
                              <label>End Date</label>
                              <div class="form-group" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                <input type="date" name="endDate" id="endDate" placeholder="End Date"
                                  [(ngModel)]="end_Date" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" [ngClass]="{ 'dark-button': selectedMode === 'dark' }"
                            class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" [ngClass]="{ 'dark-button': selectedMode === 'dark' }"
                            class="btn export-btn" (click)="exportData()">Export</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Add new Expense -->
                    <div class="modal fade" #addexpense id="addexpense" tabindex="-1" role="dialog"
                      aria-labelledby="addexpense" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                          <div class="modal-header modal-heading-main">
                            <h5 class="modal-title" id="exampleModalLongTitle">Add New Expense</h5>
                          </div>
                          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
                            <div class="modal-body">
                              <div class="tabs">
                                <div class="tab" [ngClass]="{ 'dark-tab': selectedMode === 'dark' }" (click)="updateTab(1)"
                                [class.active]="currentTab === 1">Credit</div>
                                <div class="tab" [ngClass]="{ 'dark-tab': selectedMode === 'dark' }" (click)="updateTab(2)"
                                [class.active]="currentTab === 2">Debit</div>
                              </div>
                              @if (currentTab === 1) {
                                <div class="tab-content">
                                  <div class="credit-content">
                                    <div class="credit-input-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                      <label>Amount</label>
                                      <input type="number" name="total_amount" [(ngModel)]="editeamount" placeholder="Amount"
                                        required>
                                      </div>
                                      <div class="credit-input-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                        <label>Date</label>
                                        <input type="date" name="date" [(ngModel)]="editedate" required>
                                      </div>
                                      <div class="credit-text-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                        <textarea placeholder="Description" name="description" [(ngModel)]="editedescription"
                                        required></textarea>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (currentTab === 2) {
                                  <div class="tab-content">
                                    <div class="debit-content">
                                      <div class="debit-input-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                        <label>Amount</label>
                                        <input type="number" name="total_amount" [(ngModel)]="editeamount" placeholder="Amount"
                                          required>
                                        </div>
                                        <div class="debit-input-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                          <label>Date</label>
                                          <input type="date" name="date" [(ngModel)]="editedate" required>
                                        </div>
                                        <div class="credit-input-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                          <label>Expense Type</label>
                                          <select id="type" name="type" data-toggle="dropdown" [(ngModel)]="selectedOption"
                                            (change)="selectFunction()" class="dropdown-toggle checks-dropdown form-control pl-4">
                                            <option [ngValue]="''" disabled selected>Select Reason</option>
                                            @for (item of apiData; track item) {
                                              <option [ngValue]="item.name">{{ item.name }}</option>
                                            }
                                          </select>
                                        </div>
                                        <div class="credit-text-fields" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                          <textarea placeholder="Description" name="description" [(ngModel)]="editedescription"
                                          required></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                                <div class="modal-footer" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                  <button type="submit" class="btn export-btn" [disabled]="account_id && f.invalid">
                                    {{ currentTab === 1 ? 'Add Credit' : 'Add Expense' }}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <!-- error modal -->
                        <div class="modal fade" #errorModal id="error" tabindex="-1" role="dialog" aria-labelledby="error"
                          aria-hidden="true" style="overflow-y: auto !important;">
                          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                              <div class="modal-header error-heading-main">
                                <h5 class="modal-title">Not Enough Money Available</h5>
                              </div>
                              <div class="modal-body error-body">
                                <img src="../../assets/images/question.jpg" alt="Missing image">
                                <h1>Do You Want To Take Remaining Amount From Reserve Amount?</h1>
                              </div>
                              <div class="modal-footer" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                                <button class="btn export-btn" (click)="reserveamount()">Yes</button>
                                <button class="btn export-btn" (click)="closeErrorModal()">No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="date-filter">
                        <div class="date-filter-button">
                          <label>Start Date</label>
                          <div class="form-group" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                            <input type="date" name="startDate" id="startDate" placeholder="Start Date" [(ngModel)]="startDate" />
                          </div>
                        </div>
                        <div class="date-filter-button">
                          <label>End Date</label>
                          <div class="form-group" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                            <input type="date" name="endDate" id="startDate" placeholder="Start Date" [(ngModel)]="endDate" />
                          </div>
                        </div>
                        <div class="date-filter-button apply-button">
                          <div class="btn btn-primary filter-apply" (click)="applyfilter()">
                            Apply
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="main-table-wrapper" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                      <table>
                        <tr [ngClass]="{ 'dark-backround-tr-head': selectedMode === 'dark' }">
                          <th>#</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Expense Type</th>
                          <th>Available Balance</th>
                          @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                            <th class="action-btn">Actions</th>
                          }
                        </tr>
                        @for (data of paginatedData; track data) {
                          <tr
                            [ngClass]="{ 'dark-backround-tr': selectedMode === 'dark' ,'plus-amount-td': data.account_type === 'credit', 'minus-amount-td': data.account_type === 'debit'}"
                            [ngStyle]="{'background-color': data.account_type === 'credit' ? '#E7FFDE' : '#FFF2F2'}">
                            <td>{{data.id}}</td>
                            <td>{{data.date}}</td>
                            <td [ngStyle]="{'color': data.account_type === 'credit' ? '#6aa84f' : '#cc0000'}">
                              <div class="calculation-sign">
                                @if (data.account_type === 'credit') {
                                  <p>+</p>
                                }
                                @if (data.account_type === 'debit') {
                                  <p>-</p>
                                }
                                {{data.amount}}/-PKR
                              </div>
                            </td>
                            <td>
                              <div class="expense-type" [ngClass]="{ 'dark-backround-td': selectedMode === 'dark' }"
                                [style.background-color]="getExpenseColor(data.expense_type)"
                                [style.color]="getColor(data.expense_type)">
                                @if (data.expense_type === 'reserve') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/reserve.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'sports') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/sport.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'misalliance') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/misliance.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'events') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/clarity_event-line.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'birthday') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/gift.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'patty_cash') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/money-2.png" alt="missing">
                                  </div>
                                }
                                @if (data.expense_type === 'available') {
                                  <div class="expense-type-img">
                                    <img src="../../assets/images/avail.png" alt="missing">
                                  </div>
                                }
                                <div class="expense-type-text">
                                  {{data.expense_type || '---' }}
                                </div>
                              </div>
                            </td>
                            <td [ngStyle]="{'color': data.account_type === 'credit' ? '#6aa84f' : '#cc0000'}">
                              <div class="calculation-sign">
                                {{data.available_amount}}/-PKR
                              </div>
                            </td>
                            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                              <td>
                                <div class="action-buttons">
                                  @if (isavailablefeature('edit')) {
                                    <div class="edit-button">
                                      <i class="fa fa-edit" (click)="editaccount(data)"></i>
                                    </div>
                                  }
                                  @if (isavailablefeature('delete')) {
                                    <div class="delete-button">
                                      <i class="fa fa-trash" data-toggle="modal" data-target="#deleteaccount"
                                      (click)="delete_account(data)"></i>
                                    </div>
                                  }
                                </div>
                              </td>
                            }
                          </tr>
                          <tr class="description-tr"
                            [ngClass]="{ 'dark-backround-tr': selectedMode === 'dark' ,'plus-amount-td': data.account_type === 'credit', 'minus-amount-td': data.account_type === 'debit'}"
                            [ngStyle]="{'background-color': data.account_type === 'credit' ? '#E7FFDE' : '#FFF2F2'}">
                            <th class="description">Description</th>
                            <td colspan="5" class="pt-2 pb-2">{{data.description}}</td>
                          </tr>
                          <!-- delete -->
                          <div class="modal fade" id="deleteaccount" tabindex="-1" role="dialog" aria-labelledby="deleteaccount"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                              <div class="modal-content">
                                <div class="modal-header delete-account-head">
                                  <h5 class="modal-title" id="deleteaccount">Are you Sure?</h5>
                                </div>
                                <div class="modal-body delete-account-body">
                                  <img src="../../assets/images/question.jpg" alt="Missing" w="100">
                                </div>
                                <div class="modal-footer delete-footer">
                                  <button class="delete-btn" type="button" (click)="deleteaccount()">Delete</button>
                                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </table>
                      <div class="pagination mt-2">
                        <button class="btn btn-light" [ngClass]="{ 'dark-button': selectedMode === 'dark' }"
                          (click)="previousPage()">
                        < Previous</button>
                        <span>{{ currentPage }} / {{ totalPages }}</span>
                        <button class="btn btn-light" [ngClass]="{ 'dark-button': selectedMode === 'dark' }"
                        (click)="nextPage()"> Next > </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </main>